export default __webpack_public_path__ + "static/media/ETH-BTC.cb409607.png";